/* Anime-Pass — search overlay
   ---------------------------------------------------------
   Opens from any [data-ap-search-open]. Results come from Shopify's
   predictive search endpoint rendered through a section, so prices and
   titles are formatted by Liquid rather than assembled here.

   The panel wraps a real <form action="/search">, so pressing Enter with
   scripts disabled (or the endpoint unavailable) lands on the full
   results page. */
(function () {
  'use strict';

  var SECTION = 'anime-pass-predictive-search';
  var DEBOUNCE = 250;
  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  var overlay, panel, input, results, defaults, empty, timer, lastFocused, controller;
  var ownedInert = [];

  function focusables() {
    return panel ? panel.querySelectorAll(FOCUSABLE) : [];
  }

  function setInert(state) {
    if (!overlay) return;
    var section = overlay.closest('.shopify-section');
    var parent = section ? section.parentNode : overlay.parentNode;
    if (!parent) return;

    if (state) {
      ownedInert = [];
      Array.prototype.forEach.call(parent.children, function (sibling) {
        if (sibling === section || sibling === overlay) return;
        if (!sibling.hasAttribute('inert')) {
          sibling.setAttribute('inert', '');
          ownedInert.push(sibling);
        }
      });
    } else {
      ownedInert.forEach(function (el) {
        el.removeAttribute('inert');
      });
      ownedInert = [];
    }
  }

  function trap(e) {
    if (e.key !== 'Tab') return;
    if (!panel || !isOpen()) return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function open() {
    if (!overlay) return;
    var alreadyOpen = overlay.classList.contains('open');
    if (!alreadyOpen) {
      lastFocused = document.activeElement;
    }
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setInert(true);
    if (!alreadyOpen && input) {
      input.focus();
      input.select();
    }
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setInert(false);
    if (lastFocused) {
      try { lastFocused.focus(); } catch (_) {}
    }
    lastFocused = null;
  }

  function isOpen() {
    return !!overlay && overlay.classList.contains('open');
  }

  function showDefaults() {
    if (defaults) defaults.hidden = false;
    if (results) results.hidden = true;
    if (empty) empty.hidden = true;
  }

  function announceSearch(count) {
    var el = overlay ? overlay.querySelector('[data-ap-search-status]') : null;
    if (!el) return;
    var msg;
    if (count === 0) {
      msg = 'No results found.';
    } else if (count === 1) {
      msg = '1 result found.';
    } else {
      msg = count + ' results found.';
    }
    el.textContent = '';
    requestAnimationFrame(function () { el.textContent = msg; });
  }

  function render(html) {
    if (!results) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('[data-ap-predictive]');
    var cards = fresh ? fresh.querySelectorAll('.sp-result').length : 0;

    results.innerHTML = fresh ? fresh.innerHTML : '';
    results.hidden = cards === 0;
    if (defaults) defaults.hidden = true;
    if (empty) empty.hidden = cards !== 0;
    announceSearch(cards);
  }

  function search(term) {
    if (!term) {
      showDefaults();
      return;
    }
    // Cancel any in-flight request so slow responses can't overwrite fast ones
    if (controller) controller.abort();
    controller = new AbortController();

    var url =
      ((window.routes && window.routes.predictive_search_url) || '/search/suggest') +
      '?q=' +
      encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=6&section_id=' +
      SECTION;

    fetch(url, { signal: controller.signal })
      .then(function (r) {
        return r.text();
      })
      .then(render)
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        // Endpoint unavailable (e.g. predictive search disabled) — the
        // form submit still works, so just fall back to the default panel
        showDefaults();
      });
  }

  function init() {
    var prev = overlay;
    overlay = document.querySelector('[data-ap-search-overlay]');
    if (!overlay) return;
    if (overlay === prev) return;
    panel = overlay.querySelector('.search-panel');
    input = overlay.querySelector('[data-ap-search-input]');
    results = overlay.querySelector('[data-ap-search-results]');
    defaults = overlay.querySelector('[data-ap-search-defaults]');
    empty = overlay.querySelector('[data-ap-search-empty]');

    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var term = input.value.trim();
        timer = setTimeout(function () {
          search(term);
        }, DEBOUNCE);
      });
    }

    overlay.addEventListener('click', function (e) {
      // Click on the backdrop, not the panel
      if (panel && !panel.contains(e.target)) close();
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('localization-form')) return;
    if (e.target.closest('[data-ap-search-open]')) {
      e.preventDefault();
      open();
      return;
    }
    if (e.target.closest('[data-ap-search-close]')) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) {
      if (e.key === '/') {
        var tag = (e.target.tagName || '').toLowerCase();
        if (tag === 'input' || tag === 'textarea' || e.target.isContentEditable) return;
        e.preventDefault();
        open();
      }
      return;
    }
    if (e.key === 'Escape') { close(); return; }
    trap(e);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.AnimePassSearch = { open: open, close: close };
})();
